/*
@file    index.js
@author  Autogenerated
@brief   Servicio para actualizar el idioma preferido del usuario.
*/

import { api_host } from '../../common/globals/constants';

/**
 * Actualiza el idioma preferido del usuario en el backend.
 *
 * @param {string} token   Token de autenticación (reporte).
 * @param {string} idioma  Código de idioma (por ejemplo: 'es', 'en', 'pt').
 * @returns {Promise<Response>} Promesa con la respuesta parseada a JSON.
 */
export const updateIdiomaPreferidoUsuario = (token, idioma) => {
  if (!token) {
    return Promise.reject(new Error('Token requerido para updateIdiomaPreferidoUsuario'));
  }

  const url = `${api_host}/reporte/online/indicadores/updateIdiomaPreferidoUsuario/?token=${token}`;

  return fetch(url, {
    method: 'PATCH',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token, idioma }),
  }).then(async response => {
    try {
      const data = await response.json();
      if (!response.ok) {
        const error = new Error('Error al actualizar idioma preferido');
        error.response = response;
        error.data = data;
        throw error;
      }
      return data;
    } catch (e) {
      if (!response.ok) throw e;
      return null;
    }
  });
};
